import { useDefaultTable } from './table/useDefaultTable';
import { useTable } from './table/useTable';

export const useStockManagementHasChangedSplit = () => {
    const defaultTable = useDefaultTable();
    const selectedTable = useTable();

    return selectedTable !== defaultTable;
};
